// Caixa de entrada: menções, comentários, atribuições, mudanças de status,
// prazos, lembretes, compartilhamentos e acessos a ambientes. Também mostra
// a notificação do Windows quando chega algo novo.

import * as store from "./store.js";
import * as router from "./router.js";
import { api } from "./api.js";
import { el, relTime, fmtDateTime, toast } from "./dom.js";
import { iconNode, ui } from "./icons.js";

const KIND = {
  mention: ["@", "Menção"], comment: ["💬", "Comentário"], assign: ["👤", "Atribuição"], status: ["⇄", "Status"],
  due: ["⏰", "Prazo"], reminder: ["🔔", "Lembrete"], share: ["↗", "Compartilhado"], workspace: ["🗂️", "Ambiente"], account: ["🛡️", "Conta"],
};

let filter = "all";

export async function renderInbox(host) {
  const list = el("div", { class: "inbox-list" }, el("p", { class: "muted" }, "Carregando…"));
  const tabs = el("div", { class: "picker-tabs" });
  const draw = async () => {
    tabs.replaceChildren(...[["all", "Todas"], ["unread", "Não lidas"], ["archived", "Arquivadas"]].map(([id, l]) =>
      el("button", { class: "picker-tab" + (filter === id ? " on" : ""), onclick: () => { filter = id; draw(); } }, l)),
    el("span", { class: "grow" }),
    el("button", { class: "small", onclick: async () => { await api("POST", "/notifications/read", {}); store.pollSoon(0); draw(); } }, ui("check", 14), " Marcar tudo como lido"));
    try {
      const { notifications } = await api("GET", `/notifications?filter=${filter}`);
      list.replaceChildren(...(notifications.length ? notifications.map(row) : [el("div", { class: "inbox-empty" },
        el("div", { class: "inbox-empty-icon" }, ui("inbox", 40)),
        el("p", {}, filter === "unread" ? "Você está em dia. Nada novo por aqui." : filter === "archived" ? "Nada arquivado." : "Quando alguém mencionar você, comentar nas suas páginas, atribuir uma tarefa ou o prazo chegar, o aviso aparece aqui."))]));
    } catch (err) {
      list.replaceChildren(el("p", { class: "error" }, err.message));
    }
  };
  const row = (n) => {
    const [ic] = KIND[n.kind] || ["•"];
    const open = async () => {
      if (!n.read_at) api("POST", "/notifications/read", { ids: [n.id] }).then(() => store.pollSoon(0)).catch(() => {});
      if (n.page_id) router.openPage(n.page_id);
    };
    return el("div", { class: "inbox-item" + (n.read_at ? "" : " unread"), onclick: (e) => { if (!e.target.closest("button")) open(); } },
      el("span", { class: "inbox-kind", title: KIND[n.kind]?.[1] || "" }, ic),
      el("div", { class: "inbox-main" },
        el("div", { class: "inbox-text" }, n.text),
        n.page_id ? el("div", { class: "inbox-page" }, iconNode(n.page_icon, n.page_kind === "database" ? "▦" : "📄"), " ", n.page_title || "Sem título") : null,
        el("div", { class: "muted small", title: fmtDateTime(n.created_at) }, relTime(n.created_at))),
      el("div", { class: "inbox-actions" },
        !n.read_at ? el("button", { class: "icon-btn tiny", title: "Marcar como lida", onclick: async () => { await api("POST", "/notifications/read", { ids: [n.id] }); store.pollSoon(0); draw(); } }, ui("check", 14)) : null,
        el("button", { class: "icon-btn tiny", title: n.archived_at ? "Desarquivar" : "Arquivar", onclick: async () => {
          await api("POST", n.archived_at ? "/notifications/unarchive" : "/notifications/archive", { ids: [n.id] });
          store.pollSoon(0);
          draw();
        } }, ui("archive", 14))),
      n.read_at ? null : el("span", { class: "unread-dot" }));
  };
  host.replaceChildren(el("div", { class: "list-view" }, el("h1", {}, ui("inbox", 26), " Caixa de entrada"), tabs, list));
  await draw();
  const off = store.on("notifications", () => { if (host.isConnected && list.isConnected) draw(); else off(); });
}

// Notificação do sistema para o que chegou agora (só com o app aberto).
export function initDesktopNotifications() {
  store.on("notifications", async ({ fresh }) => {
    document.title = store.state.unread ? `(${store.state.unread}) Ordo` : "Ordo";
    if (!fresh) return;
    try {
      const { notifications } = await api("GET", "/notifications?filter=unread");
      const latest = notifications[0];
      if (!latest) return;
      if (document.hasFocus() && router.current().view === "inbox") return;
      if (typeof Notification !== "undefined" && Notification.permission !== "denied") {
        const n = new Notification("Ordo", { body: latest.text, silent: false });
        n.onclick = () => {
          window.ordo?.showWindow?.();
          if (latest.page_id) router.openPage(latest.page_id);
          else router.go({ view: "inbox" });
        };
      } else toast(latest.text, 6000);
    } catch { /* sem conexão */ }
  });
}
